import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center pt-20 bg-gradient-to-br from-cream via-white to-lilac-light">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 text-center lg:text-left">
            <div className="inline-block">
              <span className="inline-block px-4 py-2 bg-golden/10 text-golden text-sm font-medium tracking-wider rounded-full">
                TRANSFORMA TU VIDA FINANCIERA
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-light leading-tight text-charcoal">
              Construye Tu{' '}
              <span className="text-golden block mt-2">
                Libertad Financiera
              </span>
            </h1>

            <p className="text-lg text-charcoal/70 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Aprende a organizar tus finanzas, eliminar deudas y crear la vida que mereces. 
              Sin culpa, sin estrés, con un plan claro y efectivo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                onClick={() => navigate('/diagnostico')}
                className="bg-golden hover:bg-golden-dark text-white px-8 py-6 text-base font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Diagnóstico Financiero Gratis
                <ArrowRight className="ml-2" size={20} />
              </Button>
              
              <Button 
                variant="outline"
                onClick={() => {
                  const element = document.querySelector('#curso');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="border-2 border-golden text-golden hover:bg-golden hover:text-white px-8 py-6 text-base font-medium rounded-lg transition-all duration-300"
              >
                Ver Curso
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8">
              <div className="text-center lg:text-left">
                <div className="text-3xl font-serif text-golden">+5000</div>
                <div className="text-sm text-charcoal/60 mt-1">Mujeres Transformadas</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-serif text-golden">+10</div>
                <div className="text-sm text-charcoal/60 mt-1">Años de Experiencia</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-serif text-golden">100%</div>
                <div className="text-sm text-charcoal/60 mt-1">Resultados Probados</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative flex items-center justify-center">
            <div className="relative rounded-2xl overflow-visible shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_mujer-invierte/artifacts/x4fy5bq6_IMG_4155%202.JPG"
                alt="Kari Rojas - Mentora Financiera"
                className="w-full max-w-md lg:max-w-lg h-auto rounded-2xl"
              />
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-golden/10 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-72 h-72 bg-lilac/20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
